"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dateMath = require("./date-arithmetic");
var localizers_1 = require("./localizers");
var directions = {
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    UP: 'UP',
    DOWN: 'DOWN'
};
var calendarViewUnits = {
    month: 'day',
    year: 'month',
    decade: 'year',
    century: 'decade'
};
function parse(date, format, culture) {
    return localizers_1.date.parse(date, format, culture);
}
exports.parse = parse;
function format(date, format, culture) {
    return localizers_1.date.format(date, format, culture);
}
exports.format = format;
function monthsInYear(year) {
    var months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    var date = new Date(year, 0, 1);
    return months.map(function (i) { return dateMath.setMonth(date, i); });
}
exports.monthsInYear = monthsInYear;
function firstVisibleDay(date, culture) {
    var firstOfMonth = dateMath.startOf(date, 'month');
    return dateMath.startOf(firstOfMonth, 'week', localizers_1.date.startOfWeek(culture));
}
exports.firstVisibleDay = firstVisibleDay;
function lastVisibleDay(date, culture) {
    var endOfMonth = dateMath.endOf(date, 'month');
    return dateMath.endOf(endOfMonth, 'week', localizers_1.date.startOfWeek(culture));
}
exports.lastVisibleDay = lastVisibleDay;
function visibleDays(date, culture) {
    var current = firstVisibleDay(date, culture);
    var last = lastVisibleDay(date, culture);
    var days = [];
    while (dateMath.lte(current, last, 'day')) {
        days.push(current);
        current = dateMath.add(current, 1, 'day');
    }
    return days;
}
exports.visibleDays = visibleDays;
function move(date, min, max, unit, direction) {
    var isMonth = unit === 'month';
    var isUpOrDown = direction === directions.UP || direction === directions.DOWN;
    var rangeUnit = calendarViewUnits[unit];
    var addUnit = isMonth && isUpOrDown ? 'week' : calendarViewUnits[unit];
    var amount = isMonth || !isUpOrDown ? 1 : 4;
    if (direction === directions.UP || direction === directions.LEFT) {
        amount *= -1;
    }
    var newDate = dateMath.add(date, amount, addUnit);
    return dateMath.inRange(newDate, min, max, rangeUnit) ? newDate : date;
}
exports.move = move;
function mergeTime(date, time, defaultDate) {
    if (time == null && date == null) {
        return defaultDate || new Date();
    }
    if (time == null) {
        time = defaultDate || new Date();
    }
    if (date == null) {
        date = defaultDate || new Date();
    }
    date = dateMath.startOf(date, 'day');
    date = dateMath.setHours(date, dateMath.getHours(time));
    date = dateMath.setMinutes(date, dateMath.getMinutes(time));
    date = dateMath.setSeconds(date, dateMath.getSeconds(time));
    return dateMath.setMilliseconds(date, dateMath.getMilliseconds(time));
}
exports.mergeTime = mergeTime;
function sameMonth(dateA, dateB) {
    return dateMath.eq(dateA, dateB, 'month');
}
exports.sameMonth = sameMonth;
function today() {
    return dateMath.startOf(new Date(), 'day');
}
exports.today = today;
function yesterday() {
    return dateMath.add(dateMath.startOf(new Date(), 'day'), -1, 'day');
}
exports.yesterday = yesterday;
function tomorrow() {
    return dateMath.add(dateMath.startOf(new Date(), 'day'), 1, 'day');
}
exports.tomorrow = tomorrow;
